export default {
      id: "ic_green-plus-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic_green-plus-usage",
      toString: function () {
        return this.url;
      }
    }